export default __webpack_public_path__ + "static/Explorerold-30bc5bee22cf0bd1103d758be04015f1.png";